<template>
    <nav class="client-nav">
        <ul class="client-nav__lists">
            <li :class="{ 'client-nav__list--on': isMain }"
                class="client-nav__list">
                <router-link to="/" class="link">A/S 접수 신청</router-link>
            </li>
            <li :class="{ 'client-nav__list--on': !isMain }"
                class="client-nav__list">
                <router-link to="/inquiry" class="link">A/S 접수 조회</router-link>
            </li>
        </ul>
    </nav>
</template>
<script>
export default {
    methods: {
        toSubmission() {
            console.log({ isMain });
            if (this.isMain) this.$emit("toggle-success");
        },
    },
    computed: {
        isMain() {
            return this.$router.currentRoute.name === "Main";
        },
    },
};
</script>
<style lang="scss" scoped>
.client-nav{
    margin-bottom: 70px;
    &__lists{
        display: flex;
        list-style: none;
    }
    &__list { flex: 1 1; font-size: 18px; color: #ef8009; border: 1px solid rgba(241, 129, 9, 1); }
    &__list .link{
        display: flex; align-items: center; justify-content: center;
        height: 60px;
    }
    &__list--on { color: #ffffff; background-color: #ef8009; border-color: rgba(241, 129, 9, 1); }
}
@media(max-width:1200px){
    .client-nav{
        margin-bottom: 35px;
        &__list { font-size: 14px; }
        &__list .link{
            height: 40px;
        }
    }
}
</style>
